import type { BillingAddress } from '@openeducation/pp-rn-shared-types';

export const shouldValidateAddress = (billingAddress: BillingAddress) => {
  const { country, ...addressFields } = billingAddress; // NOTE: ignore country, because it will be always defined
  return Object.values(addressFields).some((item: string) => item.length > 0);
};
